import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import ja from './locales/ja.json';
import zh from './locales/zh.json';

// 从环境变量读取是否启用中文
const ENABLE_CHINESE = import.meta.env.VITE_ENABLE_CHINESE === 'true';

const SUPPORTED_LANGUAGES = ENABLE_CHINESE 
  ? ['en', 'es', 'ja', 'zh'] 
  : ['en', 'es', 'ja'];

// Detect browser language
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage || '';
  // Extract language code (e.g., 'zh-CN' -> 'zh', 'en-US' -> 'en')
  const langCode = browserLang.split('-')[0].toLowerCase();
  // 如果浏览器是中文但中文被禁用，回退到英文
  if (langCode === 'zh' && !ENABLE_CHINESE) {
    return 'en';
  }
  return SUPPORTED_LANGUAGES.includes(langCode) ? langCode : 'en';
};

// Get saved language from localStorage, fallback to browser language
const storedLanguage = localStorage.getItem('polysportslab-lang');
let savedLanguage = storedLanguage || getBrowserLanguage();
// 如果保存的是中文但中文被禁用，回退到英文
if (savedLanguage === 'zh' && !ENABLE_CHINESE) {
  savedLanguage = 'en';
}
if (!storedLanguage || (storedLanguage === 'zh' && !ENABLE_CHINESE)) {
  localStorage.setItem('polysportslab-lang', savedLanguage);
}

const resources = {
  en: { translation: en },
  es: { translation: es },
  ja: { translation: ja },
};

// 只有启用中文时才加载中文资源
if (ENABLE_CHINESE) {
  resources.zh = { translation: zh };
}

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false }
});

// Save language to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('polysportslab-lang', lng);
});

// 导出支持的语言列表供其他组件使用
export const supportedLanguages = SUPPORTED_LANGUAGES;
export const isChineseEnabled = ENABLE_CHINESE;

export default i18n;
